import {
  Text,
  Box,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';
import { IconAlertCircle } from '../../../../../styles/icons';
import {useState, useEffect, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import {
  profileAccordionButton,
  profileAccordionPanel,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import Lozenge from '../../../../components/common/Lozenge';
import { useUtilityDataSelector } from '../../../../utilities/contexts';
import {updateProfileValue} from "../../../../redux/actions/user";

const EditSectionClientGroups = ({ profile }) => {
  // Get the client groups utility data
  const allClientGroups = useUtilityDataSelector((utilityData) => utilityData.clientGroups);

  // Set state
  const [clientGroupSelection, setClientGroupSelection] =
    useState(allClientGroups);

  // initialise practiceAreas
  useEffect(() => {
    let newArr = allClientGroups.map((item) => {
      return profile.clientGroups.map((elem) => elem.value).includes(item.value)
        ? { ...item, selected: true }
        : { ...item, selected: false };
    });
    setClientGroupSelection(newArr);
  }, [allClientGroups, profile]);

  // SAVE FORM
  const dispatch = useDispatch();

  const handleProfileValueUpdate = useCallback((value) => {
    setClientGroupSelection(value);
    dispatch(updateProfileValue('clientGroups', value.filter((elem) => elem.selected)))
  }, [dispatch]);

  // Render
  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            //width="100%"
            textAlign="left"
          >
            <Box>
              <Text>Client groups</Text>
              <Text textStyle="footer2" color="brand.200">
                {profile.clientGroups.map((elem) => elem.label).join(' | ')}
              </Text>
            </Box>
            {profile.clientGroups?.length > 0 ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Select the types of client that you are trained to work with
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className="w-full">
            <h3 className="text-lg text-slate-600 font-bold pb-2 flex items-center">
              Which clients are you trained to work with? Select below.
              <p className="text-red-500 superscript text-sm pl-1">*</p>
            </h3>
            <Lozenge
              title=""
              data={clientGroupSelection}
              onclick={handleProfileValueUpdate}
              multi
            />
          </div>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionClientGroups;
